import { css } from '@emotion/core';
import { variables, tokens, globalTokens, rgba } from '@domain-group/fe-brary';
var font = variables.font;
var colors = tokens.colors;
var staticColors = globalTokens.colors;
export var container = /*#__PURE__*/css("background-color:", staticColors.white, ";");
export var applyButton = {
  name: "1vw7lwg",
  styles: "position:absolute;right:27px;bottom:8px;width:83px;min-height:32px;max-height:32px;font-size:14px;padding:0;"
};
export var scrollableArea = {
  name: "13v3rg8",
  styles: "overflow-y:auto;"
};
export var fixedFooter = /*#__PURE__*/css("position:relative;border-top:1px solid ", colors.neutral.trim.default, ";height:55px;");
export var fixedHeader = {
  name: "16kiram",
  styles: "position:relative;height:40px;"
};
export var resetButton = /*#__PURE__*/css("display:inline-block;position:absolute;right:27px;top:22px;border:0;color:", colors.neutral.heavy.default, ";font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";background-color:", rgba(staticColors.black, 0), ";padding:0;cursor:pointer;&:focus{outline:none;}");